// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"84cd5cc8","378":"d6fe786a","453":"b06fd736"}[chunkId] + ".chunk.js";
};